import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@material-ui/core';
import LoadingPage from 'components/LoadingPage';
import {SuccessPage} from 'components/LoadingPage';
import {ErrorPage} from 'components/LoadingPage';
import {useEffect, useState} from 'react';
import {toSnakeCase} from './locale/utils';

const FormDialog = ({
    buttonText = 'Edit',
    buttonProps,
    title,
    children,
    submitText = 'Save',
    onSubmit = () => {},
    inProgress = false,
    success = false,
    error = false,
    successTitle = 'Data Saved',
    successMessage = null,
    errorTitle,
    errorMessage,
    reset = () => {},
}) => {
    const [open, setOpen] = useState(false);

    // reset the posting endpoint when the dialog is closed
    useEffect(() => {
        if (!open) {
            // ugly, I know. Sorry in advance
            // This prevents a rerender to blank form as user is closing dialog
            setTimeout(() => {
                reset();
            }, 500);
        }
        // eslint-disable-next-line
    }, [open]);

    return [
        <Button
            {...buttonProps}
            onClick={() => setOpen(true)}
            key='button-text'
            data-cy={toSnakeCase(buttonText)}
        >
            {buttonText}
        </Button>,
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-label='form-dialog'
            key='main-dialog'
        >
            <form onSubmit={onSubmit}>
                {title && <DialogTitle>{title}</DialogTitle>}
                {inProgress ? (
                    <Box height='250px' width='330px'>
                        <LoadingPage />
                    </Box>
                ) : error ? (
                    <Box padding={2}>
                        <ErrorPage title={errorTitle} message={errorMessage} />
                    </Box>
                ) : success ? (
                    <Box padding={2} height='250px' width='330px'>
                        <SuccessPage
                            title={successTitle}
                            message={successMessage}
                        />
                    </Box>
                ) : (
                    <>
                        <DialogContent>{children}</DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => setOpen(false)}
                                color='primary'
                            >
                                Cancel
                            </Button>
                            <Button
                                type='submit'
                                color='primary'
                                data-cy={toSnakeCase(submitText)}
                            >
                                {submitText}
                            </Button>
                        </DialogActions>
                    </>
                )}
            </form>
        </Dialog>,
    ];
};

export default FormDialog;
